import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'gateway.PremierRV.wizard.step.Coverables',
        defaultMessage: 'Coverables'
    },
    questions: {
        id: 'gateway.PremierRV.wizard.step.Questions',
        defaultMessage: 'Questions'
    },
    stepCoverages: {
        id: 'gateway.PremierRV.wizard.step.Coverages',
        defaultMessage: 'Coverages'
    },
    exposures: {
        id: 'gateway.PremierRV.wizard.step.Exposures',
        defaultMessage: 'Exposures'
    },
    anErrorOccurred: {
        id: 'quoteandbind.PremierRV.wizard.error',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.PremierRV.wizard.error.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'quoteandbind.PremierRV.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.PremierRV.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    policyDetails: {
        id: 'gateway.PremierRV.wizard.step.PolicyDetails',
        defaultMessage: 'Policy Details'
    },
    rvLocations: {
        id: 'gateway.PremierRV.wizard.step.Locations',
        defaultMessage: 'Locations'
    },
    rvDrivers: {
        id: 'gateway.PremierRV.wizard.step.Drivers',
        defaultMessage: 'Drivers'
    },
    rvVehicles: {
        id: 'gateway.PremierRV.wizard.step.Vehicles',
        defaultMessage: 'Vehicles'
    }

});
